export default "__VITE_ASSET__BXpkziZl__"